import moment from 'moment';

export const getDateDifference = (date1, date2) =>
  moment
    .duration(moment(date2).diff(moment(date1), 'minutes'), 'minutes')
    .format('h [hrs], m [min]');

export default {};
